import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { TimingMarker } from "@faire/web--source/common/timings/TimingMarker";
import { uuid } from "@faire/web--source/common/uuid";
export var TIMING_KEYS = {
    VIEW_CART: "track-view-cart-latency",
    BUY_IT_AGAIN_CHECKOUT: "track-buy-it-again-checkout-latency",
    CHECKOUT_SINGLE_BRAND: "track-checkout-single-brand-latency",
    CHECKOUT_ALL_BRANDS: "track-checkout-all-brands-latency",
    PLACE_ORDER: "track-place-order-latency"
};
export var TimingRecorder = function TimingRecorder() {
    "use strict";
    var _this = this;
    _class_call_check(this, TimingRecorder);
    this.timers = {};
    this.recordTime = function(key) {
        if (!key) {
            key = uuid();
        }
        _this.timers[key] = new TimingMarker();
        return key;
    };
    this.clearTiming = function(key) {
        if (key in _this.timers) {
            delete _this.timers[key];
        }
    };
    this.getTimingPair = function(key) {
        if (_this.timers[key]) {
            return {
                start: _this.timers[key],
                end: new TimingMarker()
            };
        }
        return null;
    };
    this.trackTiming = function(key, peteFunction) {
        var timingPair = _this.getTimingPair(key);
        if (timingPair) {
            _this.clearTiming(key);
            peteFunction(timingPair);
        }
    };
};
TimingRecorder.get = singletonGetter(TimingRecorder);
